import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithRefresh, atomFamily } from 'jotai/utils';
import { getTFERPVersion } from 'services/api/tferp';
import { useMemo } from 'react';

const tferpVersionState = atomFamily((enable: boolean) =>
  atomWithRefresh(async () => {
    try {
      if (enable) {
        const response = await getTFERPVersion();
        return response?.data?.version;
      }
      return undefined;
    } catch (err) {
      return undefined;
    }
  }),
);

export const useTFERPVersionValue = (enable: boolean) =>
  useAtomValue(useMemo(() => tferpVersionState(enable), [enable]));

export const useRefreshTFERPVersionValue = (enable: boolean) =>
  useSetAtom(useMemo(() => tferpVersionState(enable), [enable]));
